import React, { useState } from 'react';
import {
  Grid,
  TextField,
  Box,
  Button,
  Typography,
  Paper,
  InputAdornment,
  IconButton,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDropzone } from 'react-dropzone';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import axiosInstance from '../../lib/axios';
import AuthHeader from '../../Auth';
import { useNavigate } from 'react-router-dom';

const EmailForm = () => {
  const [emailDetails, setEmailDetails] = useState({
    to: '',
    subject: '',
    body: '',
  });

  const [attachments, setAttachments] = useState([]);
  const [status, setStatus] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setEmailDetails({
      ...emailDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleBodyChange = (value) => {
    setEmailDetails({
      ...emailDetails,
      body: value,
    });
  };

  const handleDrop = (acceptedFiles) => {
    setAttachments((prevAttachments) => [...prevAttachments, ...acceptedFiles]);
  };

  const removeAttachment = (indexToRemove) => {
    setAttachments((prevAttachments) =>
      prevAttachments.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!emailDetails.to || !emailDetails.subject || !emailDetails.body.trim()) {
      setStatus('All fields marked with * are mandatory.');
      return;
    }
    setStatus('Sending...');

    const emailRequest = {
      ToEmail: emailDetails.to ? [emailDetails.to] : [],
      Subject: emailDetails.subject,
      Body: emailDetails.body,
      Attachments: '',
      attachmentFilePaths: [],
    };


    const attachmentFilePaths = attachments.map((file) =>
      `E:\\${file.name.replace(/\\/g, '\\\\')}`
    );

    emailRequest.attachmentFilePaths = attachmentFilePaths;

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}EmailRequest/SendEmail`,
        emailRequest,
        AuthHeader()
      );

      setStatus(response.data.message || 'Email sent successfully!');
    } catch (error) {
      setStatus(
        error.response?.data?.message || 'An error occurred while sending the email. Please try again.'
      );
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDrop,
    accept: 'image/*,application/pdf,text/plain',
    multiple: true,
  });
  const handleCancel = () => {
    navigate(-1);
  };

  //---------------------render JSX----------------------//
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"

      style={{ maxHeight: '100vh', backgroundColor: '#f5f5f5' }}
    >
      <Grid item xs={12} md={10} lg={8}>
        <Paper elevation={3} style={{ padding: '8px', borderRadius: '10px' }}>
          <Typography variant="h4" align="center" gutterBottom>
            Send Email
          </Typography>
          <form onSubmit={handleSubmit}>
            <Box mb={2}>
              <TextField
                fullWidth
                variant="filled"
                className="custom-textfield"
                label={
                  <>
                    Email <span style={{ color: 'red' }}>*</span>
                  </>
                }
                name="to"
                type="email"
                value={emailDetails.to}
                onChange={handleChange}

                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box mb={2}>
              <TextField
                fullWidth
                variant="filled"
                className="custom-textfield"
                label={
                  <>
                    Subject <span style={{ color: 'red' }}>*</span>
                  </>
                }
                name="subject"
                value={emailDetails.subject}
                onChange={handleChange}

              />
            </Box>
            <Box mb={2}>
              <Typography variant="subtitle1" gutterBottom>
                Message<span style={{ color: 'red' }}>*</span>
              </Typography>
              <ReactQuill
                theme="snow"
                value={emailDetails.body}
                onChange={handleBodyChange}
                style={{ height: '150px', paddingBottom: '28px', }}

              />
            </Box>
            <Box
              {...getRootProps()}
              style={{
                border: '2px dashed #ccc',
                borderRadius: '4px',
                textAlign: 'center',
                cursor: 'pointer',
                backgroundColor: '#fafafa',
                height: '30px',

              }}
            >
              <input {...getInputProps()} />

              <Typography variant="body1" color="textSecondary">
                Drag & drop files here, or click to select files
              </Typography>
            </Box>
            {attachments.length > 0 && (
              <Box mb={2}>
                <Typography variant="subtitle1"><b>Attached Files:</b></Typography>
                <ul style={{
                  marginTop: '0px',

                }}>
                  {attachments.map((file, index) => (
                    <li key={index}
                      style={{ display: 'flex', alignItems: 'center' }}>
                      <Typography variant="body2" style={{ flex: 1, }}>
                        {file.name}
                      </Typography>
                      <IconButton
                        color="error"
                        onClick={() => removeAttachment(index)}
                        style={{
                          padding: '1px',
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </li>
                  ))}
                </ul>
              </Box>
            )}
            <Box
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
              style={{
                marginTop: '20px',
                marginBottom: '5px',
              }}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  backgroundColor: '#635bff',
                  '&:hover': {
                    backgroundColor: '#dddbff',
                  },
                  padding: '8px 16px',
                  fontSize: '14px',
                }}
              >
                Send Email
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleCancel}
                sx={{
                  borderColor: '#635bff',
                  color: '#635bff',
                  '&:hover': {
                    borderColor: '#dddbff',
                    color: '#635bff',
                  },
                  padding: '8px 16px',
                  marginLeft: '10px',
                  fontSize: '14px',
                }}
              >
                Cancel
              </Button>
            </Box>

          </form>
          {status && (
            <Typography
              variant="body1"
              align="center"
              color={status.includes('Error') ? 'error' : 'primary'}
              style={{ marginTop: '20px', marginBottom: '20px' }}
            >
              {status}
            </Typography>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default EmailForm;
